//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import editor from '../components/editor.vue';
import { commiRecord } from '@/api/miniProgramManagement.js';
import { dateFormatNew } from '@/utils/util.js';
export default {
  components: {
    editor,
  },
  data() {
    return {
      appid: null,
      list: [],
      page_index: 1,
      page_size: 10,
      total: 0,
      // 弹窗
      showEditor: false,
      ext_json: {},
    };
  },
  created() {
    this.appid = this.$route.query.appid;
    this.getList(this.appid);
  },
  methods: {
    async getList(appid) {
      try {
        const res = await commiRecord({
          appid,
          page_index: this.page_index,
          page_size: this.page_size,
        });
        console.log(res);
        this.list = (res?.list || []).map((item) => {
          return {
            ...item,
            create_time: dateFormatNew(new Date(item.create_time), 'YYYY-MM-dd HH:mm:SS'),
          };
        });
        this.total = Number(res.total || 0);
      } catch (err) {
        console.log('err:', err);
        this.$message.error({
          message: err.errmsg,
        });
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.page_index = 1;
      this.page_size = val;
      this.getList(this.appid);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page_index = val;
      this.getList(this.appid);
    },
    handleClick(val) {
      this.ext_json = {};
      try {
        this.ext_json = JSON.parse(val);
      } catch (err) {
        console.log(err);
      }
      this.$nextTick(() => {
        this.showEditor = true;
      });
    },
    handleClose() {
      this.ext_json = {};
      this.showEditor = false;
    },
  },
};
